import { AbstractControl, ValidationErrors } from '@angular/forms';
import { clearMaskedFieldOnKeydown, clearMaskedFieldOnPaste } from './masked-field';

/** Backend returns this when an SSN is on file but must not be revealed in plaintext. */
export const MASKED_SSN = '*********';

/** ngx-mask pattern: digits for entry, asterisks so a masked backend value can render. */
export const ssnReplacePattern = {
  X: { pattern: new RegExp(/[\d*]/), symbol: '●' },
};

export function isMaskedSsn(value: unknown): boolean {
  if (typeof value !== 'string' || !value) {
    return false;
  }
  return value.replace(/-/g, '') === MASKED_SSN;
}

/**
 * Accepts a full 9-digit SSN or a backend-masked SSN (`*********`).
 * Empty values are left to Validators.required.
 */
export function ssnValidator(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || raw === '') {
    return null;
  }

  const value = String(raw).replace(/-/g, '');
  if (isMaskedSsn(value) || /^\d{9}$/.test(value)) {
    return null;
  }

  return { ssn: true };
}

export function clearMaskedSsnOnKeydown(
  control: AbstractControl | null | undefined,
  event: KeyboardEvent
): void {
  clearMaskedFieldOnKeydown(control, event, isMaskedSsn);
}

export function clearMaskedSsnOnPaste(
  control: AbstractControl | null | undefined,
  event?: ClipboardEvent
): void {
  clearMaskedFieldOnPaste(control, isMaskedSsn, event);
}
